import {OpeningHours, OpeningHoursDay} from "models/Company";

type OpeningHoursListType = {
  openingHours: OpeningHours | undefined;
};

const daysOfWeek: string[] = [
  "Mandag",
  "Tirsdag",
  "Onsdag",
  "Torsdag",
  "Fredag",
  "Lørdag",
  "Søndag",
];

export default function OpeningHoursList({openingHours}: OpeningHoursListType) {
  return (
    <tbody>
      {openingHours?.showOpeningHours ? (
        <>
          {daysOfWeek.map((day, index) => {
            const openingHour = openingHours.days.find(
              (d: OpeningHoursDay) => d.name === day
            );

            return (
              <tr key={"openinghours_" + index}>
                <th>{day}</th>
                {openingHour?.opens && openingHour?.closes ? ( openingHour.closes === "00:00" ? (<td>Døgnåpent</td>) : (<td>{openingHour.opens} - {openingHour.closes}</td>)) : (<td>Stengt</td>)}
              </tr>
            );
          })}
        </>
      ) : (
        <tr>
          <td><p>Finner ikke eksisterende åpningstider</p></td>
        </tr>
      )}
    </tbody>
  );
}
